import { properties } from '@/utils/properties';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}

@Injectable({
  providedIn: 'root'
})
export class AdmUsuarioService {

  private baseUrl = properties.URL_ADMIN + 'adm-usuarios';

  constructor(private http: HttpClient) { }

  /**
   * Cambiar contraseña de usuario
   */
  changePassword(id: number, payload: { currentPassword: string, newPassword: string }): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(`${this.baseUrl}/${id}/change-password`, payload, properties.httpOptions);
  }
}
